import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Separator, Text} from '@/src/ui';

import css from '../styles/AddressWidgetLayout.module.css';

interface AddressWidgetLayoutProps {
  cityName?: string;
  stateName?: string;
  countryName?: string;
  onEditClick: (...args: any[]) => any;
}

const AddressWidgetLayout = ({
  cityName,
  stateName,
  countryName,
  onEditClick,
}: AddressWidgetLayoutProps) => {
  return (
    <div className={css.wrapper}>
      <div className={css.widget}>
        <div className={css.leftWidgetPart}>
          <Text
            fontFamily={Text.FONT_FAMILY.RUBIK}
            fontWeight={Text.FONT_WEIGHT.MEDIUM}
            fontSize={Text.FONT_SIZE.SIZE_32}
          >
            <TextLocal id={'profile.address'} />
          </Text>
          <div className={css.locationRow}>
            {Boolean(cityName.length) && (
              <Text
                fontSize={Text.FONT_SIZE.SIZE_16}
                fontWeight={Text.FONT_WEIGHT.BOLD}
              >
                {`${cityName} | ${stateName} | ${countryName}`}
              </Text>
            )}
          </div>
        </div>
        <div className={css.rightWidgetPart}>
          <Button
            color={Button.COLOR.SECONDARY}
            height={Button.HEIGHT.SMALL}
            onClick={onEditClick}
            border={Button.BORDER.BOLD}
          >
            <TextLocal id={'profile.edit'} />
          </Button>
        </div>
      </div>
      <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
    </div>
  );
};

export default AddressWidgetLayout;
